/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  CHANNEL_FORKING_HISTORY_DONE_FETCHING,
  CHANNEL_FORKING_HISTORY_ERROR_FETCHING,
  CHANNEL_FORKING_HISTORY_FETCHING,
  SET_FORKING_HISTORY_CHANNEL_IDS,
  SET_FORKING_HISTORY_QUERY_DATA,
  FORKING_HISTORY_SET_CSV,
  CLEAR_FORKING_HISTORY,
  ForkingHistoryActions
} from 'store/action/forking-history';
import {IStartEnd} from 'interfaces/analyticsProps';
import {IPortalError} from 'utility/error-handler';

export interface IForkingHistoryState {
  forkingHistory: Record<string, string>[];
  isFetching: boolean;
  error: null | IPortalError;
  csv: string;
  queryData: IStartEnd;
}

const initialState: IForkingHistoryState = {
  forkingHistory: [],
  isFetching: false,
  error: null,
  csv: '',
  queryData: {
    start: new Date(),
    end: new Date()
  }
};
const forkingHistory: Reducer<Readonly<IForkingHistoryState>, ForkingHistoryActions> = (
  state: IForkingHistoryState = initialState,
  action: ForkingHistoryActions
) => {
  switch (action.type) {
    case SET_FORKING_HISTORY_CHANNEL_IDS: {
      return {
        ...initialState,
        channelIDs: [...action.payload]
      };
    }

    case CHANNEL_FORKING_HISTORY_FETCHING: {
      return {
        ...state,
        isFetching: true
      };
    }

    case FORKING_HISTORY_SET_CSV: {
      return {
        ...state,
        csv: action.payload
      };
    }

    case CHANNEL_FORKING_HISTORY_DONE_FETCHING: {
      return {
        ...state,
        isFetching: false,
        forkingHistory: [...action.payload, ...state.forkingHistory] as Record<string, string>[],
        error: null
      };
    }

    case CHANNEL_FORKING_HISTORY_ERROR_FETCHING: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    case SET_FORKING_HISTORY_QUERY_DATA: {
      return {
        ...state,
        queryData: {
          end: action.payload.end || state.queryData.end,
          start: action.payload.start
        }
      };
    }

    case CLEAR_FORKING_HISTORY: {
      return {...initialState};
    }

    default:
      return state;
  }
};

export default forkingHistory;